export default "__VITE_ASSET__24ae01d4__"